import { CustomButton } from 'components/header/style';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Button, Typography, closeModal } from 'enable-ui';
import { showSaveAllScheduleSelector, useScheduleStore } from 'stores';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { getAssessmentsInCourseColumn } from 'modules/dashboard/core/columns';
import { LessonType, type Lessons } from 'modules/dashboard/core/type';
import { ButtonOnboardingResults } from 'modules/learners/styles/learner-layout';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';

import ButtonAddComp from '../components/ButtonAddComp';
import { LessonsInClassTable } from '../components/LessonsInClassTable';
import { getLessonsInClassColumn } from '../core/columns';
import { useLessonsAssessmentsController } from '../core/controller/lessons-assessments';

export const LessonsAssessmentPage = () => {
  const showSaveAllShedule = useScheduleStore(showSaveAllScheduleSelector);

  const isShowButton = showSaveAllShedule.some((item) => item.show);

  const {
    onClickAction,
    goToLessonAssessmentDetailPage,
    lessonsAndAssessments,
    onChangeSelectedLessons,
    selectedLessons,
    handleAddLesson,
    handleDelete,
    handleUpdateLessonInClass,
    handleChangeValue,
    onChangeSelectedAssessments,
    selectedAssessments,
    handleAddAssessment,
    onExportClassAssessments,
    onSaveAllToBeScheduled,

    institutionId,
  } = useLessonsAssessmentsController();

  const lessonColumns = getLessonsInClassColumn(onChangeSelectedLessons, selectedLessons);

  const assessmentColumns = getAssessmentsInCourseColumn(
    onChangeSelectedAssessments,
    selectedAssessments,
  );

  const renderLessonsInClass = (title: LessonType, data: Lessons[]) => {
    return (
      <div
        className="border-container p-16"
        style={{
          marginTop: 24,
          marginBottom: 32,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography
            variant="h4"
            weight={700}
            className="first-letter-uppercase"
            style={{ marginBottom: 16 }}
          >
            {title}
          </Typography>
          {title === LessonType.TO_BE_SCHEDULED && isShowButton && (
            <CustomButton>
              <Button
                variant="outlined"
                style={{ padding: '0px 16px', height: 32 }}
                onClick={() => onSaveAllToBeScheduled(data)}
              >
                Save all
              </Button>
            </CustomButton>
          )}
        </div>

        <LessonsInClassTable
          typeLesson={title}
          lessons={data}
          handleUpdateLesson={handleUpdateLessonInClass}
          onClickAction={onClickAction}
          goToLessonAssessmentDetailPage={goToLessonAssessmentDetailPage}
          totalLearner={lessonsAndAssessments.totalLearner}
          handleChangeValue={handleChangeValue}
        />
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
        <ButtonOnboardingResults variant="outlined" onClick={onExportClassAssessments}>
          <DownloadIcon style={{ marginRight: 6 }} />
          Assessment results
        </ButtonOnboardingResults>
        <ButtonAddComp
          lessonColumns={lessonColumns}
          handleAddLesson={handleAddLesson}
          handleAddAssessment={handleAddAssessment}
          assessmentColumns={assessmentColumns}
          institutionId={institutionId}
        />
      </div>

      {renderLessonsInClass(LessonType.TODAY, lessonsAndAssessments.today)}
      {renderLessonsInClass(LessonType.UP_COMMING, lessonsAndAssessments.future)}
      {renderLessonsInClass(LessonType.TO_BE_SCHEDULED, lessonsAndAssessments.unscheduled)}
      {renderLessonsInClass(LessonType.PAST, lessonsAndAssessments.past)}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_LESSON_IN_CLASS}
        content={
          'Doing this will also delete all results of clients completed the lesson. There’s no way to undo this.'
        }
        header={'Delete lesson'}
        onCancel={() => closeModal(MODAL_KEY.DELETE_LESSON_IN_CLASS)}
        onSubmit={handleDelete}
      />
    </div>
  );
};
